<!-- 搜索公用组件 -->
<template>
  <div>
    <div class="search-content">
      <el-form
        :inline="true"
        class="search-form"
        :model="formInline"
        size="small"
        @submit.native.prevent
      >
        <el-form-item
          v-for="(item, i) in conditions"
          :key="i"
          :label="item.type == 'button' ? '' : item.label"
        >
          <!-- prop="formInline[item.name]" 2023.11.23注释 后续有问题再打开-->
          <!-- 输入框 -->
          <el-input
            v-if="item.type == 'input'"
            v-model.trim="formInline[item.name]"
            :placeholder="item.placeholder ? item.placeholder : item.label"
            @keyup.enter.native="$emit('handleSearch', formInline)"
            @input="search"
          ></el-input>
          <!-- 下拉框 -->
          <el-select
            clearable
            filterable
            v-if="item.type == 'select'"
            v-model="formInline[item.name]"
            :placeholder="item.label"
            @clear="handleClear(item.isChangeCompany)"
            @change="handleChange($event, item.isChangeCompany)"
          >
            <el-option
              v-for="(option, i) in item.options"
              :key="i"
              :label="option.label"
              :value="option.value"
            ></el-option>
          </el-select>

          <el-select
            clearable
            v-if="item.type == 'selectNext'"
            v-model="formInline[item.name]"
            :placeholder="item.label"
          >
            <el-option
              v-for="(option, i) in companyList"
              :key="i"
              :label="option.label"
              :value="option.value"
            ></el-option>
          </el-select>

          <!-- 级联下拉框 -->
          <el-cascader
            clearable
            v-if="item.type == 'cascader'"
            v-model="formInline[item.name]"
            :placeholder="item.label"
            :props="{ lazy: true, lazyLoad: item.lazyLoad }"
          >
          </el-cascader>
          <!-- 日期选择器 -->
          <el-date-picker
            v-if="item.type == 'date'"
            v-model="formInline[item.name]"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <el-date-picker
            v-if="item.type == 'datetwo'"
            v-model="formInline[item.name]"
            type="date"
            placeholder="选择日期"
            align="right"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          <el-date-picker
            v-if="item.type == 'dateMonth'"
            v-model="formInline[item.name]"
            type="month"
            align="right"
            value-format="yyyy-M"
            :placeholder="item.label"
          >
            >
          </el-date-picker>
          <!-- 按钮 -->
          <el-button
            v-if="item.type == 'button'"
            type="primary"
            @click="onSubmit"
            >{{ item.label }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
/** 表格头部搜索组件
 * props 参数conditions
 * name:属性key; type分为:input|select|date;
 * options:type为select需下拉选项
 * 例：{ label: "团队名称", name: "name", type: "input" },
 *
 */
export default {
  name: "SearchForm",
  props: {
    conditions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      keyWord: false,
      keyWordTwo: false,
      formInline: {},
      companyList: [],

      pickerOptions: {
        disabledDate: time => {
          return time.getTime() > new Date();
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  methods: {
    handleClear(e) {
      // console.log(e);
      if (e && e == "1") {
        this.$set(this.formInline, "companyId", "");
      }
    },
    search() {
      for (let i in this.conditions) {
        // console.log("object", this.formInline[this.conditions[i].name]);

        if (this.formInline[this.conditions[i].name]) {
          let regEn = /[`~!@#$%^&*()_+<>?:"{}.\/;[\]]/gi;
          let regCn = /[·！#￥（——）：；“”‘、|《。》？、【】[\]]/gi;
          if (/\s/g.test(this.formInline[this.conditions[i].name])) {
            this.$message({
              type: "warning",
              message: "搜索框不能包含空格"
            });
            this.keyWord = true;
            return;
          } else if (
            regEn.test(this.formInline[this.conditions[i].name]) ||
            regCn.test(this.formInline[this.conditions[i].name])
          ) {
            // console.log(this.searchData,"gy");
            this.$message({
              type: "warning",
              message: "搜索框不能包含特殊字符"
            });
            this.keyWordTwo = true;
            return;
          } else {
            this.keyWord = false;
            this.keyWordTwo = false;
          }
        } else {
          this.keyWord = false;
          this.keyWordTwo = false;
        }
      }
    },
    onSubmit() {
      if (this.keyWord) {
        this.$message({
          type: "warning",
          message: "搜索框不能包含空格"
        });
        return;
      } else if (this.keyWordTwo) {
        this.$message({
          type: "warning",
          message: "搜索框不能包含特殊字符"
        });
        return;
      } else {
        this.$emit("handleSearch", this.formInline);
      }
    },

    handleChange(val, e) {
      //  console.log(e);
      if (e && e == "1") {
        this.$set(this.formInline, "companyId", "");
      }
      this.$axios
        .post(
          this.$server + "/company/companyByBrand",
          this.$qs.stringify({ brandId: val })
        )
        .then(res => {
          if (res.data.code == "0") {
            this.companyList = res.data.data.map(v => {
              return { label: v.companyName, value: v.companyId };
            });
          } else {
            // this.$message.error(res.data.message);
          }
        });
    }
  },
  created() {
    this.conditions.forEach(v => {
      if (v.default) {
        this.$set(this.formInline, v.name, v.default);
      }
      // console.log(this.formInline,"kkk");
    });
  }
};
</script>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/common/page/SearchForm.vue